import { observer } from 'mobx-react-lite';
import { useForm } from 'react-hook-form';
import md5 from 'blueimp-md5';
import { yupResolver } from '@hookform/resolvers/yup';
import { Modal, message } from 'antd';
import { ComponentType } from 'react';
import { pure } from 'recompose';

import { ILoginBase, ILoginEmailRequest } from '../../types/ILogin';
import { LoginSchema } from '../../validation/LoginSchema';
import { useRootStore } from '../../providers/RootStoreProvider';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';

//styles
import {
    LoginWrapper,
    LoginContainer,
    LoginTitle,
    TitleContainer,
    LogoApp,
    LoginInputText,
    LoginButton,
    SpinLogin,
    LoginToolName
} from './LoginView.styles';

import { APIResponse } from '../../models/APIResponse';
import { ILoginResponseBase } from '../../types/ITypeBase';
import { APP_BUTTON_TYPE } from '../../types/IGlobal';

interface Props {}

export const LoginView: ComponentType<Props> = pure(
    observer(({}) => {
        const store = useRootStore();
        const navigation = useNavigate();

        const { login, loadingLogin } = store.authStore;

        const {
            register,
            handleSubmit,
            formState: { errors }
        } = useForm<ILoginBase>({
            resolver: yupResolver(LoginSchema)
        });

        const onSubmit = async (data: ILoginBase) => {
            const params: ILoginEmailRequest = {
                data: {
                    userName: data.account,
                    password: md5(data.password)
                }
            };

            const result: APIResponse<ILoginResponseBase> = await login(params);
            if (result && result.isSuccess()) handleLoginSuccess();
            else handleLoginFailure();
        };

        const handleLoginSuccess = () => {
            message.success('Đăng nhập hệ thống thành công !');
            navigation('/net/list');
        };

        const handleLoginFailure = () => {
            Modal.error({
                title: 'Đăng nhập không thành công',
                content: 'Vui lòng kiểm tra lại thông tin và thử lại',
                centered: true
            });
        };

        return (
            <LoginWrapper>
                <LoginContainer>
                    <TitleContainer title="1.1.0">
                        <LoginTitle>Đăng nhập</LoginTitle>
                        <LoginToolName>Checkin Tool</LoginToolName>
                    </TitleContainer>

                    <form onSubmit={handleSubmit(onSubmit)}>
                        <LoginInputText
                            {...register('account')}
                            //defaultValue="sonnp"
                            isError={errors.account ? 'error' : ''}
                            placeholder="Tên đăng nhập / Email"></LoginInputText>
                        <LoginInputText
                            {...register('password')}
                            type="password"
                            //defaultValue="123456"
                            isError={errors.password ? 'error' : ''}
                            placeholder="Mật khẩu"></LoginInputText>
                        {!loadingLogin ? (
                            <LoginButton
                                type="submit"
                                typeButton={APP_BUTTON_TYPE.PRIMARY}>
                                Đăng nhập
                            </LoginButton>
                        ) : (
                            <LoginButton
                                style={{ pointerEvents: 'none' }}
                                typeButton={APP_BUTTON_TYPE.PRIMARY}>
                                <SpinLogin />
                            </LoginButton>
                        )}
                    </form>
                    {/* <ForgetPass onClick={() => handleForgotPass()} href="#">
                        Quên mật khẩu?
                    </ForgetPass>
                    <NoAccountWrapper>
                        <NoAccountText>Bạn chưa có tài khoản</NoAccountText>
                        <NoAccountLink
                            onClick={() => handleRegisterAccount()}
                            href="#">
                            Đăng ký
                        </NoAccountLink>
                    </NoAccountWrapper> */}
                </LoginContainer>
            </LoginWrapper>
        );
    })
);
